import { Badge } from 'antd'
import { theme } from 'theme'

const reservationBadgeStyle = {
  backgroundColor: theme.colors.grey12,
  color: theme.colors.grey7,
  boxShadow: `${theme.colors.grey12} 0px 0px 0px 0.5px`,
}

const ReservationBadge: React.FC = () => {
  return <Badge count="Reservation" style={reservationBadgeStyle} />
}

export default ReservationBadge
